// Third party and libarries
import React, { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client';
import { Card, Col, Row, Form, Button } from "react-bootstrap"

//components
import BreadCrumbComponent from '../../components/BreadCrumbComponent'
import { covertTimeZone } from '../../helper';
import CurrentDateComponents from '../../components/CurrentDateComponents';
import OrderTables from './OrderTables';
import { GET_SALE_ORDERS } from '../../apollo/order/query';
import _ from 'lodash';
import moment from 'moment';
import PaginationHelper from '../../components/PaginationHelper';

// icons 

export default function OrderLists() {

    // state hook
    const [isCurrentModals, setIsCurrentModals] = useState(false);
    const [cdFillter, setCdFillter] = useState({
        createdAt_gte: "",
        createdAt_lt: "",
    });
    const [activeButton, setActiveButton] = useState("thisMonth");
    const [orderListDatas, setOrderListDatas] = useState({
        datas: [], total: 0
    })
    const { _limit, _skip, Pagination_helper } = PaginationHelper();
    const [productName, setProductName] = useState()


    // apollo client
    const [getOrders, { data: saleOrders, loading: loadingOrders }] = useLazyQuery(GET_SALE_ORDERS, { fetchPolicy: 'cache-and-network' })


    // useeffect hook
    useEffect(() => {
        fetchOrders()
    }, [cdFillter, _skip, productName])

    useEffect(() => {
        if (saleOrders) {
            setOrderListDatas({
                datas: saleOrders?.reportSaleOrders?.data,
                total: saleOrders?.reportSaleOrders?.total,
            })
        }
    }, [saleOrders])

    // fetch orders all
    const fetchOrders = async () => {
        try {
            if (loadingOrders) return;
            let shopData = JSON.parse(localStorage.getItem('SHOP_DATA'))

            let _where = {
                shop: shopData?.id,
                isDeleted: false,
            }

            if (!_.isEmpty(productName)) {
                _where = {
                    ..._where,
                    productName: productName
                }
            }

            if (!_.isEmpty(cdFillter?.createdAt_gte) || !_.isEmpty(cdFillter?.createdAt_lt)) {
                _where = {
                    ..._where,
                    createdAt_gte: moment(cdFillter?.createdAt_gte).format("YYYY-MM-DD"),
                    createdAt_lt: moment(cdFillter.createdAt_lt)
                        .add(1, "days")
                        .format("YYYY-MM-DD"),
                };
            }

            await getOrders({
                variables: {
                    where: _where,
                    skip: (_skip - 1) * _limit,
                    limit: _limit,
                    // orderBy: "createdAt_DESC"
                }
            })

        } catch (error) {
            console.log({ error })
        }
    }

    return (
        <Card style={{ minHeight: '100vh', border: 'none' }}>
            <BreadCrumbComponent
                txtSecond={`ລາຍງານການຂາຍ`}
            />


            <Card style={{ border: 'none', padding: 20 }}>
                <Row>
                    <Col md={9}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>ຊື່ສິນຄ້າ</Form.Label>
                            <Form.Control value={productName} onChange={(e) => setProductName(e?.target?.value)} type="text" placeholder="..." />
                        </Form.Group>
                    </Col>
                    
                    <Col md={3} >
                        <Form.Group className="mb-3" controlId="current-date" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}>
                            <Form.Label>ວັນທີ, ເດືອນ, ປີ</Form.Label>
                            <Button
                                variant="outline-secondary"
                                onClick={() => setIsCurrentModals(true)}
                                style={{ minWidth: 220 }}
                            >
                                {!cdFillter ? (
                                    "mm/dd/yyyy"
                                ) : (
                                    <>
                                        {covertTimeZone(cdFillter?.createdAt_gte) +
                                            " - " +
                                            covertTimeZone(cdFillter?.createdAt_lt)} 
                                    </>
                                )}
                            </Button>
                        </Form.Group>

                    </Col>
                </Row>

                <OrderTables orderListDatas={orderListDatas} saleOrders={saleOrders} _limit={_limit} _skip={_skip} loadingOrders={loadingOrders} />

                <div>{Pagination_helper(orderListDatas?.total, "", ``)}</div>


            </Card>

            <CurrentDateComponents
                onCloseModal={() => setIsCurrentModals(false)}
                openModal={isCurrentModals}
                setCdFillter={setCdFillter}
                setActiveButton={setActiveButton}
                activeButton={activeButton}
            />

        </Card>
    )
}
